// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-text {
	font-size: 1.1rem;
	font-weight: 600;
	margin-left: -15px;
	margin-right: 10px;
	margin-bottom: 0;
	color: var(--color-primary-green) !important;
	padding-top: 3px;
}

.sidebar-wrapper {
	width: 270px;
	height: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	background: var(--color-sidebar-bg);
	border-right: 1px solid var(--color-sidebar-border);
	z-index: 11;
	transition: all .2s ease-out
}

.sidebar-header {
	width: 270px;
	height: 45px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	bottom: 0;
	padding: 0 15px;
	z-index: 5;
	background: var(--color-sidebar-bg);
	background-clip: padding-box;
	border-bottom: 1px solid var(--color-sidebar-border);
}
@media screen and (max-width: 768px) {
	.sidebar-wrapper{
		width:100%;
	}
	.sidebar-header{
		width:100%;
	}
}

.sidebar-body{
	overflow-y:auto;
	height: calc(100% - 45px);
}
.sidebar-body::-webkit-scrollbar{
	width:10px;
}
.sidebar-body::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.menu-label {
	padding: 20px 15px 5px 5px;
	color: var(--color-menu-label);
	text-transform: uppercase;
	font-size: 1rem;
	letter-spacing: .5px
}

/* .metismenu .has-arrow:after {
	position: absolute;
	content: "";
	width: .5em;
	height: .5em;
	border-style: solid;
	border-width: 1.2px 0 0 1.2px;
	border-color: initial;
	right: 15px;
	transform: rotate(-45deg) translateY(-50%);
	transform-origin: top;
	top: 50%;
	transition: all .3s ease-out
} */

/* .has-arrow.open:after {
	transform: rotate(-180deg) ;
} */

.rightArrow{
	font-size: .7rem;
	position: absolute;
	top:35%;
	width: .5em;
	height: .5em;
	right: 15px;
	transition: transform .15s;
}
.arrow-flipped{
	transform: translateY(5px) rotate(180deg);
}

@media screen {
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 70px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {
		display: none
	}
	.email-toggle-btn {
		display: none!important
	}
	.chat-toggle-btn {
		display: none!important
	}
}

.sidebar-wrapper ul {
	padding: 0;
	margin: 0;
	list-style: none;
	background: 0 0
}

.sidebar-wrapper .metismenu {
	background: 0 0;
	display: flex;
	padding: 8px;
	padding-top:0;
	flex-direction: column
}

.sidebar-wrapper .metismenu li+li {
	margin-top: 2px
}

.sidebar-wrapper .metismenu li:first-child {
	margin-top: 5px
}

.sidebar-wrapper .metismenu li:last-child {
	margin-bottom: 5px
}
.sidebar-wrapper .metismenu>li {
	display: flex;
	flex-direction: column;
	position: relative
}

.sidebar-wrapper .metismenu a {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: left;
	padding: 8px 15px;
	font-size: 0.875rem;
	color: var(--color-menu-text);
	outline-width: 0;
	text-overflow: ellipsis;
	overflow: hidden;
	letter-spacing: .5px;
	border: 1px solid #ffffff00;
	transition: all .3s ease-out;
    text-decoration: none;
}

.parent-icon {
	color: var(--color-icon-slate);
	font-size: 14px;
	line-height: 1
}

.sidebar-wrapper .metismenu a .menu-title {
	margin-left: 10px;
	margin-top: 5px;
}

.sidebar-wrapper .metismenu ul a {
	padding: 6px 15px 6px 50px;
	font-size: 0.875rem;
	letter-spacing: .5px;
	border: 0
}


.sidebar-wrapper .metismenu ul {
	background: var(--color-sidebar-bg);
}

.sidebar-wrapper .metismenu ul ul a {
	padding: 8px 15px 8px 60px
}

.sidebar-wrapper .metismenu ul ul ul a {
	padding: 8px 15px 8px 45px
}

.sidebar-wrapper .metismenu li button:hover,
.sidebar-wrapper .metismenu li a:hover{
	background-color: var(--color-menu-hover-bg);
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu li button:hover .menu-title,
.sidebar-wrapper .metismenu li a:hover .menu-title{
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu li a,
.sidebar-wrapper .metismenu li button{
	border-radius: 6px;
}
.sidebar-wrapper .metismenu .mm-active>a,
.sidebar-wrapper .metismenu a:active,
.sidebar-wrapper .metismenu a:focus,
.sidebar-wrapper .metismenu a:hover {
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
	text-shadow: none;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    
	background-color: var(--color-menu-active-bg) !important;
    color: var(--color-menu-active-text) !important;
	text-shadow: none;
    border-left: 3px solid var(--color-menu-active-text) !important;
    border-radius: 6px;
}
.sidebar-wrapper .metismenu ul a i {
    margin-right: 10px;
    font-weight: 900;
}

.toggle-icon {
	font-size: 22px;
	cursor:pointer;
	color:var(--color-primary-orange);
	margin-left: 30px;
}
.toggle-icon i{
	margin-left: 70px;
}

.mm-collapse:not(.mm-show) {
    display: none;
}
.mm-collapse li i{
	font-size: 9px;
}
.mm-collapse .parent-icon i{
	font-size: 16px;
}
.mm-collapse.mm-show li .sidebar-button{
	width:100%;
}
.sidebar-button{
	position: relative;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 8px 15px;
    font-size: 0.875rem;
    color: var(--color-menu-text);
    outline-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: .5px;
    border: 1px solid #ffffff00;
    transition: all .3s ease-out;
    text-decoration: none;
	background: none;
}

.padding-left-12{
	padding-left: 12px;
}

.menu-title{
font-weight: 600 !important;
}
.sub-menu-title{
	/* padding-left:13px; */
	font-size:.9rem;
}

.dropdown-menu{
	border-radius: 0;
	background-color: var(--color-sidebar-bg);
	box-shadow: 0 4px 12px rgba(0,0,0,0.3);
	max-height: calc(100vh - 390px);
	overflow-y: auto;
	overflow-x: hidden;
	padding-top: 0;
	scrollbar-width: thin;
	scrollbar-color: var(--color-white-a50) transparent;
	scrollbar-gutter: stable;
}
.dropdown-item {
	white-space: nowrap;
}

.dropdown-menu::-webkit-scrollbar{
	width:10px;
	background-color: #3f4349;
}
.dropdown-menu::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.mm-collapse.mm-show .dropdown-item{
	padding-left: 40px;
}
.dropdown-item, .dropdown-item a{
	color: var(--color-menu-text);
	font-size: 0.875rem;
	letter-spacing: .5px;
	height:50px;
	line-height: 52px;
	padding: 0 1rem;
	text-decoration: none;
}
.dropdown-item.active, .dropdown-item.active:hover{
	background-color: inherit;
}
.dropdown-item:hover, .dropdown-item a:hover{
	color: var(--color-menu-hover-text);
	background-color: inherit;
	transition: color .25s;
}
.logo-text {
	font-size: 1.1rem;
	font-weight: 600;
	margin-left: -15px;
	margin-right: 10px;
	margin-bottom: 0;
	color: var(--color-white);
	padding-top: 3px;
}

.sidebar-wrapper {
	width: 270px;
	height: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	background: var(--color-sidebar-bg);
	border-right: 1px solid var(--color-sidebar-border);
	z-index: 11;
	transition: all .2s ease-out
}

.sidebar-header {
	width: 270px;
	height: 45px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	bottom: 0;
	padding: 0 15px;
	z-index: 5;
	background: var(--color-sidebar-bg);
	background-clip: padding-box;
	border-bottom: 1px solid var(--color-sidebar-border);
}
@media screen and (max-width: 768px) {
	.sidebar-wrapper{
		width:100%;
	}
	.sidebar-header{
		width:100%;
	}
}

.sidebar-body{
	overflow-y:auto;
	height: calc(100% - 45px);
}
.sidebar-body::-webkit-scrollbar{
	width:10px;
}
.sidebar-body::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.menu-label {
	padding: 20px 15px 5px 5px;
	color: var(--color-menu-label);
	text-transform: uppercase;
	font-size: 1rem;
	letter-spacing: .5px
}

/* .metismenu .has-arrow:after {
	position: absolute;
	content: "";
	width: .5em;
	height: .5em;
	border-style: solid;
	border-width: 1.2px 0 0 1.2px;
	border-color: initial;
	right: 15px;
	transform: rotate(-45deg) translateY(-50%);
	transform-origin: top;
	top: 50%;
	transition: all .3s ease-out
} */

/* .has-arrow.open:after {
	transform: rotate(-180deg) ;
} */

.rightArrow{
	font-size: .7rem;
	position: absolute;
	top:35%;
	width: .5em;
	height: .5em;
	right: 15px;
	transition: transform .15s;
}
.arrow-flipped{
	transform: translateY(5px) rotate(180deg);
}

@media screen {
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 55px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {
		width: 70px
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {
		justify-content: center
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {
		display: none
	}
	.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {
		display: none
	}
	.email-toggle-btn {
		display: none!important
	}
	.chat-toggle-btn {
		display: none!important
	}
}

.sidebar-wrapper ul {
	padding: 0;
	margin: 0;
	list-style: none;
	background: 0 0
}

.sidebar-wrapper .metismenu {
	background: 0 0;
	display: flex;
	padding: 8px;
	padding-top:0;
	flex-direction: column
}

.sidebar-wrapper .metismenu li+li {
	margin-top: 2px
}

.sidebar-wrapper .metismenu li:first-child {
	margin-top: 5px
}

.sidebar-wrapper .metismenu li:last-child {
	margin-bottom: 5px
}
.sidebar-wrapper .metismenu>li {
	display: flex;
	flex-direction: column;
	position: relative
}

.sidebar-wrapper .metismenu a {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: left;
	padding: 8px 15px;
	font-size: 0.875rem;
	color: var(--color-menu-text);
	outline-width: 0;
	text-overflow: ellipsis;
	overflow: hidden;
	letter-spacing: .5px;
	border: 1px solid #ffffff00;
	transition: all .3s ease-out;
    text-decoration: none;
}

.parent-icon {
	color: var(--color-icon-slate);
	font-size: 14px;
	line-height: 1
}

.sidebar-wrapper .metismenu a .menu-title {
	margin-left: 10px;
	margin-top: 5px;
}

.sidebar-wrapper .metismenu ul a {
	padding: 6px 15px 6px 50px;
	font-size: 0.875rem;
	letter-spacing: .5px;
	border: 0
}


.sidebar-wrapper .metismenu ul {
	background: var(--color-sidebar-bg);
}

.sidebar-wrapper .metismenu ul ul a {
	padding: 8px 15px 8px 60px
}

.sidebar-wrapper .metismenu ul ul ul a {
	padding: 8px 15px 8px 45px
}

.sidebar-wrapper .metismenu li button:hover,
.sidebar-wrapper .metismenu li a:hover{
	background-color: var(--color-menu-hover-bg);
	color: var(--color-menu-hover-text);
}
.sidebar-wrapper .metismenu li a,
.sidebar-wrapper .metismenu li button{
	border-radius: 6px;
}
.sidebar-wrapper .metismenu .mm-active>a,
.sidebar-wrapper .metismenu a:active,
.sidebar-wrapper .metismenu a:focus,
.sidebar-wrapper .metismenu a:hover {
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
	text-shadow: none;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    
	background-color: var(--color-menu-active-bg) !important;
    color: var(--color-menu-active-text) !important;
	text-shadow: none;
    border-left: 3px solid var(--color-menu-active-text) !important;
    border-radius: 6px;
}
.sidebar-wrapper .metismenu ul a i {
    margin-right: 10px;
    font-weight: 900;
}

.toggle-icon {
	font-size: 22px;
	cursor:pointer;
	color:var(--color-primary-orange);
	margin-left: 30px;
}
.toggle-icon i{
	margin-left: 70px;
}

.mm-collapse:not(.mm-show) {
    display: none;
}
.mm-collapse li i{
	font-size: 9px;
}
.mm-collapse .parent-icon i{
	font-size: 16px;
}
.mm-collapse.mm-show li .sidebar-button{
	width:100%;
}
.sidebar-button{
	position: relative;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 8px 15px;
    font-size: 0.875rem;
    color: var(--color-menu-text);
    outline-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: .5px;
    border: 1px solid #ffffff00;
    transition: all .3s ease-out;
    text-decoration: none;
	background: none;
}

.padding-left-12{
	padding-left: 12px;
}

.menu-title{
font-weight: 600 !important;
}
.sub-menu-title{
	/* padding-left:13px; */
	font-size:.9rem;
}
.company-logo{
	width: 180px;
	padding: 3px 0px;
}
.company-logo-col{
	width: 40px;
	padding: 3px 0px;
	margin-left: -10px;
}

.dropdown-menu{
	border-radius: 0;
	background-color: var(--color-sidebar-bg);
	box-shadow: 0 4px 12px rgba(0,0,0,0.3);
	max-height: calc(100vh - 390px);
	/* overflow-y: auto;
	overflow-x: hidden; */
}

.dropdown-menu::-webkit-scrollbar{
	width:10px;
	background-color: #3f4349;
}
.dropdown-menu::-webkit-scrollbar-thumb{
	background-color: var(--color-white-a50);
	border-radius: 5px;
}
.mm-collapse.mm-show .dropdown-item{
	padding-left: 40px;
}
.dropdown-item, .dropdown-item a{
	color: var(--color-menu-text);
	font-size: 0.875rem;
	letter-spacing: .5px;
	height:50px;
	line-height: 52px;
	padding: 0 1rem;
	text-decoration: none;
}
.dropdown-item.active, .dropdown-item.active:hover{
	background-color: inherit;
}
.dropdown-item:hover, .dropdown-item a:hover{
	color: var(--color-menu-hover-text);
	background-color: inherit;
	transition: color .25s;
}
.dropdown-item.header{
	color: var(--color-primary-green);
	font-size: 1.2em;
	background: var(--color-primary-orange) !important;
	padding: 0 1rem 0 2.375rem;
	border-bottom: none;
    box-shadow: inset 1px -7px 0 -7px var(--color-primary-green);}

.collapsed-menu-parent-icon{
	cursor: pointer;
	width: 100%;
	color: var(--color-icon-slate);
	padding: 13px 0;
	font-size: 18px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.collapsed-menu-parent-icon.hovered{
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
}
.collapsed-menu-parent-icon.hovered i{
	color: var(--color-primary-green) !important;
}
.collapsed-menu-parent-icon i{
	color: inherit;
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{
	color: var(--color-menu-active-text) !important;
}

.sidebar-body .metismenu li a.active{
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
	color: var(--color-menu-active-text);
}

.toggle-menu{
	cursor: pointer;
    padding: 22px;
    font-size: 24px;
	color: var(--color-primary-green);
	margin-left: -15px;
}
.toggle-menu:hover{
	text-shadow: 0px 0px 20px var(--color-primary-green);
}
.dropdown-item:focus{
	background-color: inherit;
	color: var(--color-white);
}

.last-child .mm-collapse{
	padding-bottom: 100px;
}
/* --- Sidebar Layer Fix --- */
.sidebar-wrapper,
.sidebar-header {
  position: fixed;
  z-index: 2000 !important;
}

/* Keep main content below the sidebar */
/* .main,
.content-wrapper,
.ticket-info-card,
.card {
  position: relative;
  z-index: 1;
} */

/* Optional: ensure mobile sidebar still stays on top */
@media (max-width: 768px) {
  .sidebar-wrapper {
    width: 100%;
    z-index: 3000 !important;
  }
}
.css-26l3qy-menu {
  z-index: 9999 !important;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-menu-hover-text);
}
.content-wrapper {
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}
.content-wrapper::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}
.sidebar-wrapper .metismenu .menu-active .parent-icon,
.sidebar-body .metismenu li a.active .parent-icon,
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu a,
.sidebar-wrapper .metismenu ul a,
.sidebar-wrapper .metismenu ul ul a,
.sidebar-wrapper .metismenu ul ul ul a,
.sidebar-button,
.dropdown-item,
.dropdown-item a,
.menu-title,
.sub-menu-title {
	font-size: 0.9rem !important;
	font-weight: 600 !important;
}

.collapsed-menu-parent-icon{
	cursor: pointer;
	width: 100%;
	color: var(--color-icon-slate);
	padding: 13px 0;
	font-size: 18px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.collapsed-menu-parent-icon.hovered{
	background-color: var(--color-menu-active-bg);
	color: var(--color-menu-active-text);
	
}
.collapsed-menu-parent-icon.hovered i{
	color: var(--color-primary-green) !important;
}
.collapsed-menu-parent-icon i{
	color: inherit;
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
}
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{
	color: var(--color-menu-active-text) !important;
}

.sidebar-body .metismenu li a.active{
	background-color: var(--color-menu-active-bg);
	border-left: 5px solid var(--color-menu-active-text);
	color: var(--color-menu-active-text);
}

.toggle-menu{
	cursor: pointer;
    padding: 22px;
    font-size: 24px;
	color: var(--color-primary-green);
}
.toggle-menu:hover{
	text-shadow: 0px 0px 20px var(--color-primary-green);
}
.dropdown-item:focus{
	background-color: inherit;
	color: var(--color-white);
}

.last-child .mm-collapse{
	padding-bottom: 100px;
}
/* --- Sidebar Layer Fix --- */
.sidebar-wrapper,
.sidebar-header {
  position: fixed;
  z-index: 2000 !important;
}

/* Keep main content below the sidebar */
/* .main,
.content-wrapper,
.ticket-info-card,
.card {
  position: relative;
  z-index: 1;
} */

/* Optional: ensure mobile sidebar still stays on top */
@media (max-width: 768px) {
  .sidebar-wrapper {
    width: 100%;
    z-index: 3000 !important;
  }
}
.css-26l3qy-menu {
  z-index: 9999 !important;
}
.sidebar-wrapper .metismenu li button:hover .parent-icon,
.sidebar-wrapper .metismenu li a:hover .parent-icon{
	color: var(--color-menu-hover-text);
}
.content-wrapper {
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}
.content-wrapper::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}
.sidebar-wrapper .metismenu .menu-active .parent-icon,
.sidebar-body .metismenu li a.active .parent-icon,
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {
	color: var(--color-primary-green) !important;
}
.sidebar-wrapper .metismenu a,
.sidebar-wrapper .metismenu ul a,
.sidebar-wrapper .metismenu ul ul a,
.sidebar-wrapper .metismenu ul ul ul a,
.sidebar-button,
.dropdown-item,
.dropdown-item a,
.menu-title,
.sub-menu-title {
	font-size: 0.9rem !important;
	font-weight: 600 !important;
}
/* Active indicator without layout shift */
.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) {
	border-left: none;
	box-shadow: inset 5px 0 0 var(--color-menu-active-text);
}

.sidebar-body .metismenu li a.active {
	border-left: 1px solid transparent;
	box-shadow: inset 5px 0 0 var(--color-menu-active-text);
}

.sidebar-wrapper .metismenu .menu-active,
.menu-active:hover {
	border-left: 1px solid transparent !important;
	box-shadow: inset 3px 0 0 var(--color-menu-active-text);
}
/* Scroll long collapsed-sidebar dropdowns */
.dropdown-menu {
	overflow-y: auto;
	overflow-x: hidden;
	padding-top: 0;
	scrollbar-width: thin;
	scrollbar-color: var(--color-white-a50) transparent;
}
.dropdown-menu::-webkit-scrollbar {
	width: 6px;
	background-color: transparent;
}

/* Keep the menu title visible while scrolling */
.dropdown-item.header {
	position: sticky;
	top: 0;
	z-index: 1;
}
.dropdown-item,
.dropdown-item a {
	line-height: 50px;
}
.dropdown-item a {
	display: block;
}
.dropdown-menu .dropdown-item.header:not(:only-child) {
	border-bottom: 1px solid var(--color-sidebar-border);
	box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/containers/menu/Menu.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,4CAA4C;CAC5C,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,MAAM;CACN,SAAS;CACT,OAAO;CACP,mCAAmC;CACnC,mDAAmD;CACnD,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,MAAM;CACN,SAAS;CACT,eAAe;CACf,UAAU;CACV,mCAAmC;CACnC,4BAA4B;CAC5B,oDAAoD;AACrD;AACA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;AACA;CACC,UAAU;AACX;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,0BAA0B;CAC1B,8BAA8B;CAC9B,yBAAyB;CACzB,eAAe;CACf;AACD;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;GAEG;;AAEH;CACC,gBAAgB;CAChB,kBAAkB;CAClB,OAAO;CACP,WAAW;CACX,YAAY;CACZ,WAAW;CACX,0BAA0B;AAC3B;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;AACD;;AAEA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CAGf,aAAa;CACb,YAAY;CACZ,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;AACA;CAGC,aAAa;CAIb,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;CACnB,6BAA6B;CAC7B,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;CACpB,2BAA2B;CAC3B,4BAA4B;IACzB,qBAAqB;AACzB;;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,oBAAoB;CACpB;AACD;;;AAGA;CACC,mCAAmC;AACpC;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,4CAA4C;CAC5C,4CAA4C;AAC7C;AACA;;CAEC,4CAA4C;AAC7C;AACA;;CAEC,kBAAkB;AACnB;AACA;;;;CAIC,6CAA6C;CAC7C,oCAAoC;;CAEpC,iBAAiB;AAClB;AACA;;CAEC,4CAA4C;AAC7C;AACA;CACC,wDAAwD;IACrD,+CAA+C;CAClD,iBAAiB;IACd,+DAA+D;IAC/D,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iCAAiC;CACjC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;CACxB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;AACA,2BAA2B;AAC3B;AACA;CACC,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,yCAAyC;CACzC,sCAAsC;CACtC,+BAA+B;CAC/B,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,qBAAqB;CACrB,mDAAmD;CACnD,wBAAwB;AACzB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,yBAAyB;AAC1B;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,oBAAoB;CACpB,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,qBAAqB;AACtB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,MAAM;CACN,SAAS;CACT,OAAO;CACP,mCAAmC;CACnC,mDAAmD;CACnD,WAAW;CACX;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,MAAM;CACN,SAAS;CACT,eAAe;CACf,UAAU;CACV,mCAAmC;CACnC,4BAA4B;CAC5B,oDAAoD;AACrD;AACA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;AACA;CACC,UAAU;AACX;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,0BAA0B;CAC1B,8BAA8B;CAC9B,yBAAyB;CACzB,eAAe;CACf;AACD;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;GAEG;;AAEH;CACC,gBAAgB;CAChB,kBAAkB;CAClB,OAAO;CACP,WAAW;CACX,YAAY;CACZ,WAAW;CACX,0BAA0B;AAC3B;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;CACA;EACC;CACD;AACD;;AAEA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB;AACD;;AAEA;CACC,eAAe;CAGf,aAAa;CACb,YAAY;CACZ,aAAa;CAIb;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;AACA;CAGC,aAAa;CAIb,sBAAsB;CACtB;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;CACnB,6BAA6B;CAC7B,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;CACpB,2BAA2B;CAC3B,4BAA4B;IACzB,qBAAqB;AACzB;;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,oBAAoB;CACpB;AACD;;;AAGA;CACC,mCAAmC;AACpC;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;CAEC,4CAA4C;CAC5C,mCAAmC;AACpC;AACA;;CAEC,kBAAkB;AACnB;AACA;;;;CAIC,6CAA6C;CAC7C,oCAAoC;;CAEpC,iBAAiB;AAClB;AACA;;CAEC,4CAA4C;AAC7C;AACA;CACC,wDAAwD;IACrD,+CAA+C;CAClD,iBAAiB;IACd,+DAA+D;IAC/D,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iCAAiC;CACjC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;IACI,aAAa;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;CACxB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;AACA,2BAA2B;AAC3B;AACA;CACC,uBAAuB;CACvB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,yCAAyC;CACzC,sCAAsC;CACtC,+BAA+B;CAC/B;sBACqB;AACtB;;AAEA;CACC,UAAU;CACV,yBAAyB;AAC1B;AACA;CACC,wCAAwC;CACxC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,oBAAoB;CACpB,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,qBAAqB;AACtB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,iCAAiC;CACjC,gBAAgB;CAChB,kDAAkD;CAClD,0BAA0B;CAC1B,mBAAmB;IAChB,4DAA4D,CAAC;;AAEjE;CACC,eAAe;CACf,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,6CAA6C;CAC7C,oCAAoC;;AAErC;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,cAAc;AACf;AACA;CACC,6CAA6C;CAC7C,oDAAoD;AACrD;AACA;CACC,+CAA+C;AAChD;;AAEA;CACC,6CAA6C;CAC7C,oDAAoD;CACpD,oCAAoC;AACrC;;AAEA;CACC,eAAe;IACZ,aAAa;IACb,eAAe;CAClB,iCAAiC;CACjC,kBAAkB;AACnB;AACA;CACC,oDAAoD;AACrD;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;AACA,8BAA8B;AAC9B;;EAEE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;;;;;;GAMG;;AAEH,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,wBAAwB;EAC1B;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;;CAEC,mCAAmC;AACpC;AACA;EACE,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;AACrC;AACA;EACE,aAAa,EAAE,uBAAuB;AACxC;AACA;;;CAGC,4CAA4C;AAC7C;AACA;;;;;;;;;CASC,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,WAAW;CACX,8BAA8B;CAC9B,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,6CAA6C;CAC7C,oCAAoC;;AAErC;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,cAAc;AACf;AACA;CACC,6CAA6C;CAC7C,oDAAoD;AACrD;AACA;CACC,+CAA+C;AAChD;;AAEA;CACC,6CAA6C;CAC7C,oDAAoD;CACpD,oCAAoC;AACrC;;AAEA;CACC,eAAe;IACZ,aAAa;IACb,eAAe;CAClB,iCAAiC;AAClC;AACA;CACC,oDAAoD;AACrD;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;AACA,8BAA8B;AAC9B;;EAEE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;;;;;;GAMG;;AAEH,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,wBAAwB;EAC1B;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;;CAEC,mCAAmC;AACpC;AACA;EACE,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;AACrC;AACA;EACE,aAAa,EAAE,uBAAuB;AACxC;AACA;;;CAGC,4CAA4C;AAC7C;AACA;;;;;;;;;CASC,4BAA4B;CAC5B,2BAA2B;AAC5B;AACA,0CAA0C;AAC1C;CACC,iBAAiB;CACjB,uDAAuD;AACxD;;AAEA;CACC,kCAAkC;CAClC,uDAAuD;AACxD;;AAEA;;CAEC,6CAA6C;CAC7C,uDAAuD;AACxD;AACA,4CAA4C;AAC5C;CACC,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,qBAAqB;CACrB,mDAAmD;AACpD;AACA;CACC,UAAU;CACV,6BAA6B;AAC9B;;AAEA,gDAAgD;AAChD;CACC,gBAAgB;CAChB,MAAM;CACN,UAAU;AACX;AACA;;CAEC,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,oDAAoD;CACpD,gBAAgB;AACjB","sourcesContent":[".logo-text {\r\n\tfont-size: 1.1rem;\r\n\tfont-weight: 600;\r\n\tmargin-left: -15px;\r\n\tmargin-right: 10px;\r\n\tmargin-bottom: 0;\r\n\tcolor: var(--color-primary-green) !important;\r\n\tpadding-top: 3px;\r\n}\r\n\r\n.sidebar-wrapper {\r\n\twidth: 270px;\r\n\theight: 100%;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tbackground: var(--color-sidebar-bg);\r\n\tborder-right: 1px solid var(--color-sidebar-border);\r\n\tz-index: 11;\r\n\ttransition: all .2s ease-out\r\n}\r\n\r\n.sidebar-header {\r\n\twidth: 270px;\r\n\theight: 45px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tpadding: 0 15px;\r\n\tz-index: 5;\r\n\tbackground: var(--color-sidebar-bg);\r\n\tbackground-clip: padding-box;\r\n\tborder-bottom: 1px solid var(--color-sidebar-border);\r\n}\r\n@media screen and (max-width: 768px) {\r\n\t.sidebar-wrapper{\r\n\t\twidth:100%;\r\n\t}\r\n\t.sidebar-header{\r\n\t\twidth:100%;\r\n\t}\r\n}\r\n\r\n.sidebar-body{\r\n\toverflow-y:auto;\r\n\theight: calc(100% - 45px);\r\n}\r\n.sidebar-body::-webkit-scrollbar{\r\n\twidth:10px;\r\n}\r\n.sidebar-body::-webkit-scrollbar-thumb{\r\n\tbackground-color: var(--color-white-a50);\r\n\tborder-radius: 5px;\r\n}\r\n.menu-label {\r\n\tpadding: 20px 15px 5px 5px;\r\n\tcolor: var(--color-menu-label);\r\n\ttext-transform: uppercase;\r\n\tfont-size: 1rem;\r\n\tletter-spacing: .5px\r\n}\r\n\r\n/* .metismenu .has-arrow:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\twidth: .5em;\r\n\theight: .5em;\r\n\tborder-style: solid;\r\n\tborder-width: 1.2px 0 0 1.2px;\r\n\tborder-color: initial;\r\n\tright: 15px;\r\n\ttransform: rotate(-45deg) translateY(-50%);\r\n\ttransform-origin: top;\r\n\ttop: 50%;\r\n\ttransition: all .3s ease-out\r\n} */\r\n\r\n/* .has-arrow.open:after {\r\n\ttransform: rotate(-180deg) ;\r\n} */\r\n\r\n.rightArrow{\r\n\tfont-size: .7rem;\r\n\tposition: absolute;\r\n\ttop:35%;\r\n\twidth: .5em;\r\n\theight: .5em;\r\n\tright: 15px;\r\n\ttransition: transform .15s;\r\n}\r\n.arrow-flipped{\r\n\ttransform: translateY(5px) rotate(180deg);\r\n}\r\n\r\n@media screen {\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {\r\n\t\twidth: 55px\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\r\n\t\twidth: 55px\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\r\n\t\tjustify-content: center\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\r\n\t\twidth: 70px\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {\r\n\t\tjustify-content: center\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {\r\n\t\tdisplay: none\r\n\t}\r\n\t.email-toggle-btn {\r\n\t\tdisplay: none!important\r\n\t}\r\n\t.chat-toggle-btn {\r\n\t\tdisplay: none!important\r\n\t}\r\n}\r\n\r\n.sidebar-wrapper ul {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n\tbackground: 0 0\r\n}\r\n\r\n.sidebar-wrapper .metismenu {\r\n\tbackground: 0 0;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding: 8px;\r\n\tpadding-top:0;\r\n\t-webkit-box-orient: vertical;\r\n\t-webkit-box-direction: normal;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column\r\n}\r\n\r\n.sidebar-wrapper .metismenu li+li {\r\n\tmargin-top: 2px\r\n}\r\n\r\n.sidebar-wrapper .metismenu li:first-child {\r\n\tmargin-top: 5px\r\n}\r\n\r\n.sidebar-wrapper .metismenu li:last-child {\r\n\tmargin-bottom: 5px\r\n}\r\n.sidebar-wrapper .metismenu>li {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-orient: vertical;\r\n\t-webkit-box-direction: normal;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\tposition: relative\r\n}\r\n\r\n.sidebar-wrapper .metismenu a {\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: left;\r\n\tpadding: 8px 15px;\r\n\tfont-size: 0.875rem;\r\n\tcolor: var(--color-menu-text);\r\n\toutline-width: 0;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tletter-spacing: .5px;\r\n\tborder: 1px solid #ffffff00;\r\n\ttransition: all .3s ease-out;\r\n    text-decoration: none;\r\n}\r\n\r\n.parent-icon {\r\n\tcolor: var(--color-icon-slate);\r\n\tfont-size: 14px;\r\n\tline-height: 1\r\n}\r\n\r\n.sidebar-wrapper .metismenu a .menu-title {\r\n\tmargin-left: 10px;\r\n\tmargin-top: 5px;\r\n}\r\n\r\n.sidebar-wrapper .metismenu ul a {\r\n\tpadding: 6px 15px 6px 50px;\r\n\tfont-size: 0.875rem;\r\n\tletter-spacing: .5px;\r\n\tborder: 0\r\n}\r\n\r\n\r\n.sidebar-wrapper .metismenu ul {\r\n\tbackground: var(--color-sidebar-bg);\r\n}\r\n\r\n.sidebar-wrapper .metismenu ul ul a {\r\n\tpadding: 8px 15px 8px 60px\r\n}\r\n\r\n.sidebar-wrapper .metismenu ul ul ul a {\r\n\tpadding: 8px 15px 8px 45px\r\n}\r\n\r\n.sidebar-wrapper .metismenu li button:hover,\r\n.sidebar-wrapper .metismenu li a:hover{\r\n\tbackground-color: var(--color-menu-hover-bg);\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.sidebar-wrapper .metismenu li button:hover .menu-title,\r\n.sidebar-wrapper .metismenu li a:hover .menu-title{\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.sidebar-wrapper .metismenu li a,\r\n.sidebar-wrapper .metismenu li button{\r\n\tborder-radius: 6px;\r\n}\r\n.sidebar-wrapper .metismenu .mm-active>a,\r\n.sidebar-wrapper .metismenu a:active,\r\n.sidebar-wrapper .metismenu a:focus,\r\n.sidebar-wrapper .metismenu a:hover {\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tcolor: var(--color-menu-active-text);\r\n\t\r\n\ttext-shadow: none;\r\n}\r\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\r\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    \r\n\tbackground-color: var(--color-menu-active-bg) !important;\r\n    color: var(--color-menu-active-text) !important;\r\n\ttext-shadow: none;\r\n    border-left: 3px solid var(--color-menu-active-text) !important;\r\n    border-radius: 6px;\r\n}\r\n.sidebar-wrapper .metismenu ul a i {\r\n    margin-right: 10px;\r\n    font-weight: 900;\r\n}\r\n\r\n.toggle-icon {\r\n\tfont-size: 22px;\r\n\tcursor:pointer;\r\n\tcolor:var(--color-primary-orange);\r\n\tmargin-left: 30px;\r\n}\r\n.toggle-icon i{\r\n\tmargin-left: 70px;\r\n}\r\n\r\n.mm-collapse:not(.mm-show) {\r\n    display: none;\r\n}\r\n.mm-collapse li i{\r\n\tfont-size: 9px;\r\n}\r\n.mm-collapse .parent-icon i{\r\n\tfont-size: 16px;\r\n}\r\n.mm-collapse.mm-show li .sidebar-button{\r\n\twidth:100%;\r\n}\r\n.sidebar-button{\r\n\tposition: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: left;\r\n    padding: 8px 15px;\r\n    font-size: 0.875rem;\r\n    color: var(--color-menu-text);\r\n    outline-width: 0;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    letter-spacing: .5px;\r\n    border: 1px solid #ffffff00;\r\n    transition: all .3s ease-out;\r\n    text-decoration: none;\r\n\tbackground: none;\r\n}\r\n\r\n.padding-left-12{\r\n\tpadding-left: 12px;\r\n}\r\n\r\n.menu-title{\r\nfont-weight: 600 !important;\r\n}\r\n.sub-menu-title{\r\n\t/* padding-left:13px; */\r\n\tfont-size:.9rem;\r\n}\r\n\r\n.dropdown-menu{\r\n\tborder-radius: 0;\r\n\tbackground-color: var(--color-sidebar-bg);\r\n\tbox-shadow: 0 4px 12px rgba(0,0,0,0.3);\r\n\tmax-height: calc(100vh - 390px);\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\tpadding-top: 0;\r\n\tscrollbar-width: thin;\r\n\tscrollbar-color: var(--color-white-a50) transparent;\r\n\tscrollbar-gutter: stable;\r\n}\r\n.dropdown-item {\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.dropdown-menu::-webkit-scrollbar{\r\n\twidth:10px;\r\n\tbackground-color: #3f4349;\r\n}\r\n.dropdown-menu::-webkit-scrollbar-thumb{\r\n\tbackground-color: var(--color-white-a50);\r\n\tborder-radius: 5px;\r\n}\r\n.mm-collapse.mm-show .dropdown-item{\r\n\tpadding-left: 40px;\r\n}\r\n.dropdown-item, .dropdown-item a{\r\n\tcolor: var(--color-menu-text);\r\n\tfont-size: 0.875rem;\r\n\tletter-spacing: .5px;\r\n\theight:50px;\r\n\tline-height: 52px;\r\n\tpadding: 0 1rem;\r\n\ttext-decoration: none;\r\n}\r\n.dropdown-item.active, .dropdown-item.active:hover{\r\n\tbackground-color: inherit;\r\n}\r\n.dropdown-item:hover, .dropdown-item a:hover{\r\n\tcolor: var(--color-menu-hover-text);\r\n\tbackground-color: inherit;\r\n\ttransition: color .25s;\r\n}\r\n.logo-text {\r\n\tfont-size: 1.1rem;\r\n\tfont-weight: 600;\r\n\tmargin-left: -15px;\r\n\tmargin-right: 10px;\r\n\tmargin-bottom: 0;\r\n\tcolor: var(--color-white);\r\n\tpadding-top: 3px;\r\n}\r\n\r\n.sidebar-wrapper {\r\n\twidth: 270px;\r\n\theight: 100%;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tbackground: var(--color-sidebar-bg);\r\n\tborder-right: 1px solid var(--color-sidebar-border);\r\n\tz-index: 11;\r\n\ttransition: all .2s ease-out\r\n}\r\n\r\n.sidebar-header {\r\n\twidth: 270px;\r\n\theight: 45px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tpadding: 0 15px;\r\n\tz-index: 5;\r\n\tbackground: var(--color-sidebar-bg);\r\n\tbackground-clip: padding-box;\r\n\tborder-bottom: 1px solid var(--color-sidebar-border);\r\n}\r\n@media screen and (max-width: 768px) {\r\n\t.sidebar-wrapper{\r\n\t\twidth:100%;\r\n\t}\r\n\t.sidebar-header{\r\n\t\twidth:100%;\r\n\t}\r\n}\r\n\r\n.sidebar-body{\r\n\toverflow-y:auto;\r\n\theight: calc(100% - 45px);\r\n}\r\n.sidebar-body::-webkit-scrollbar{\r\n\twidth:10px;\r\n}\r\n.sidebar-body::-webkit-scrollbar-thumb{\r\n\tbackground-color: var(--color-white-a50);\r\n\tborder-radius: 5px;\r\n}\r\n.menu-label {\r\n\tpadding: 20px 15px 5px 5px;\r\n\tcolor: var(--color-menu-label);\r\n\ttext-transform: uppercase;\r\n\tfont-size: 1rem;\r\n\tletter-spacing: .5px\r\n}\r\n\r\n/* .metismenu .has-arrow:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\twidth: .5em;\r\n\theight: .5em;\r\n\tborder-style: solid;\r\n\tborder-width: 1.2px 0 0 1.2px;\r\n\tborder-color: initial;\r\n\tright: 15px;\r\n\ttransform: rotate(-45deg) translateY(-50%);\r\n\ttransform-origin: top;\r\n\ttop: 50%;\r\n\ttransition: all .3s ease-out\r\n} */\r\n\r\n/* .has-arrow.open:after {\r\n\ttransform: rotate(-180deg) ;\r\n} */\r\n\r\n.rightArrow{\r\n\tfont-size: .7rem;\r\n\tposition: absolute;\r\n\ttop:35%;\r\n\twidth: .5em;\r\n\theight: .5em;\r\n\tright: 15px;\r\n\ttransition: transform .15s;\r\n}\r\n.arrow-flipped{\r\n\ttransform: translateY(5px) rotate(180deg);\r\n}\r\n\r\n@media screen {\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .logo-text {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper {\r\n\t\twidth: 55px\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\r\n\t\twidth: 55px\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header .toggle-icon {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\r\n\t\tjustify-content: center\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .sidebar-header {\r\n\t\twidth: 70px\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu a {\r\n\t\tjustify-content: center\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .menu-title {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li ul {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu li.menu-label {\r\n\t\tdisplay: none\r\n\t}\r\n\t.wrapper.toggled:not(.sidebar-hovered) .sidebar-wrapper .metismenu .has-arrow:after {\r\n\t\tdisplay: none\r\n\t}\r\n\t.email-toggle-btn {\r\n\t\tdisplay: none!important\r\n\t}\r\n\t.chat-toggle-btn {\r\n\t\tdisplay: none!important\r\n\t}\r\n}\r\n\r\n.sidebar-wrapper ul {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n\tbackground: 0 0\r\n}\r\n\r\n.sidebar-wrapper .metismenu {\r\n\tbackground: 0 0;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding: 8px;\r\n\tpadding-top:0;\r\n\t-webkit-box-orient: vertical;\r\n\t-webkit-box-direction: normal;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column\r\n}\r\n\r\n.sidebar-wrapper .metismenu li+li {\r\n\tmargin-top: 2px\r\n}\r\n\r\n.sidebar-wrapper .metismenu li:first-child {\r\n\tmargin-top: 5px\r\n}\r\n\r\n.sidebar-wrapper .metismenu li:last-child {\r\n\tmargin-bottom: 5px\r\n}\r\n.sidebar-wrapper .metismenu>li {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-orient: vertical;\r\n\t-webkit-box-direction: normal;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\tposition: relative\r\n}\r\n\r\n.sidebar-wrapper .metismenu a {\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: left;\r\n\tpadding: 8px 15px;\r\n\tfont-size: 0.875rem;\r\n\tcolor: var(--color-menu-text);\r\n\toutline-width: 0;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\tletter-spacing: .5px;\r\n\tborder: 1px solid #ffffff00;\r\n\ttransition: all .3s ease-out;\r\n    text-decoration: none;\r\n}\r\n\r\n.parent-icon {\r\n\tcolor: var(--color-icon-slate);\r\n\tfont-size: 14px;\r\n\tline-height: 1\r\n}\r\n\r\n.sidebar-wrapper .metismenu a .menu-title {\r\n\tmargin-left: 10px;\r\n\tmargin-top: 5px;\r\n}\r\n\r\n.sidebar-wrapper .metismenu ul a {\r\n\tpadding: 6px 15px 6px 50px;\r\n\tfont-size: 0.875rem;\r\n\tletter-spacing: .5px;\r\n\tborder: 0\r\n}\r\n\r\n\r\n.sidebar-wrapper .metismenu ul {\r\n\tbackground: var(--color-sidebar-bg);\r\n}\r\n\r\n.sidebar-wrapper .metismenu ul ul a {\r\n\tpadding: 8px 15px 8px 60px\r\n}\r\n\r\n.sidebar-wrapper .metismenu ul ul ul a {\r\n\tpadding: 8px 15px 8px 45px\r\n}\r\n\r\n.sidebar-wrapper .metismenu li button:hover,\r\n.sidebar-wrapper .metismenu li a:hover{\r\n\tbackground-color: var(--color-menu-hover-bg);\r\n\tcolor: var(--color-menu-hover-text);\r\n}\r\n.sidebar-wrapper .metismenu li a,\r\n.sidebar-wrapper .metismenu li button{\r\n\tborder-radius: 6px;\r\n}\r\n.sidebar-wrapper .metismenu .mm-active>a,\r\n.sidebar-wrapper .metismenu a:active,\r\n.sidebar-wrapper .metismenu a:focus,\r\n.sidebar-wrapper .metismenu a:hover {\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tcolor: var(--color-menu-active-text);\r\n\t\r\n\ttext-shadow: none;\r\n}\r\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\r\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.sidebar-wrapper .metismenu .menu-active, .menu-active:hover {    \r\n\tbackground-color: var(--color-menu-active-bg) !important;\r\n    color: var(--color-menu-active-text) !important;\r\n\ttext-shadow: none;\r\n    border-left: 3px solid var(--color-menu-active-text) !important;\r\n    border-radius: 6px;\r\n}\r\n.sidebar-wrapper .metismenu ul a i {\r\n    margin-right: 10px;\r\n    font-weight: 900;\r\n}\r\n\r\n.toggle-icon {\r\n\tfont-size: 22px;\r\n\tcursor:pointer;\r\n\tcolor:var(--color-primary-orange);\r\n\tmargin-left: 30px;\r\n}\r\n.toggle-icon i{\r\n\tmargin-left: 70px;\r\n}\r\n\r\n.mm-collapse:not(.mm-show) {\r\n    display: none;\r\n}\r\n.mm-collapse li i{\r\n\tfont-size: 9px;\r\n}\r\n.mm-collapse .parent-icon i{\r\n\tfont-size: 16px;\r\n}\r\n.mm-collapse.mm-show li .sidebar-button{\r\n\twidth:100%;\r\n}\r\n.sidebar-button{\r\n\tposition: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: left;\r\n    padding: 8px 15px;\r\n    font-size: 0.875rem;\r\n    color: var(--color-menu-text);\r\n    outline-width: 0;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    letter-spacing: .5px;\r\n    border: 1px solid #ffffff00;\r\n    transition: all .3s ease-out;\r\n    text-decoration: none;\r\n\tbackground: none;\r\n}\r\n\r\n.padding-left-12{\r\n\tpadding-left: 12px;\r\n}\r\n\r\n.menu-title{\r\nfont-weight: 600 !important;\r\n}\r\n.sub-menu-title{\r\n\t/* padding-left:13px; */\r\n\tfont-size:.9rem;\r\n}\r\n.company-logo{\r\n\twidth: 180px;\r\n\tpadding: 3px 0px;\r\n}\r\n.company-logo-col{\r\n\twidth: 40px;\r\n\tpadding: 3px 0px;\r\n\tmargin-left: -10px;\r\n}\r\n\r\n.dropdown-menu{\r\n\tborder-radius: 0;\r\n\tbackground-color: var(--color-sidebar-bg);\r\n\tbox-shadow: 0 4px 12px rgba(0,0,0,0.3);\r\n\tmax-height: calc(100vh - 390px);\r\n\t/* overflow-y: auto;\r\n\toverflow-x: hidden; */\r\n}\r\n\r\n.dropdown-menu::-webkit-scrollbar{\r\n\twidth:10px;\r\n\tbackground-color: #3f4349;\r\n}\r\n.dropdown-menu::-webkit-scrollbar-thumb{\r\n\tbackground-color: var(--color-white-a50);\r\n\tborder-radius: 5px;\r\n}\r\n.mm-collapse.mm-show .dropdown-item{\r\n\tpadding-left: 40px;\r\n}\r\n.dropdown-item, .dropdown-item a{\r\n\tcolor: var(--color-menu-text);\r\n\tfont-size: 0.875rem;\r\n\tletter-spacing: .5px;\r\n\theight:50px;\r\n\tline-height: 52px;\r\n\tpadding: 0 1rem;\r\n\ttext-decoration: none;\r\n}\r\n.dropdown-item.active, .dropdown-item.active:hover{\r\n\tbackground-color: inherit;\r\n}\r\n.dropdown-item:hover, .dropdown-item a:hover{\r\n\tcolor: var(--color-menu-hover-text);\r\n\tbackground-color: inherit;\r\n\ttransition: color .25s;\r\n}\r\n.dropdown-item.header{\r\n\tcolor: var(--color-primary-green);\r\n\tfont-size: 1.2em;\r\n\tbackground: var(--color-primary-orange) !important;\r\n\tpadding: 0 1rem 0 2.375rem;\r\n\tborder-bottom: none;\r\n    box-shadow: inset 1px -7px 0 -7px var(--color-primary-green);}\r\n\r\n.collapsed-menu-parent-icon{\r\n\tcursor: pointer;\r\n\twidth: 100%;\r\n\tcolor: var(--color-icon-slate);\r\n\tpadding: 13px 0;\r\n\tfont-size: 18px;\r\n\tborder-radius: 6px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n.collapsed-menu-parent-icon.hovered{\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tcolor: var(--color-menu-active-text);\r\n\t\r\n}\r\n.collapsed-menu-parent-icon.hovered i{\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.collapsed-menu-parent-icon i{\r\n\tcolor: inherit;\r\n}\r\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tborder-left: 5px solid var(--color-menu-active-text);\r\n}\r\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{\r\n\tcolor: var(--color-menu-active-text) !important;\r\n}\r\n\r\n.sidebar-body .metismenu li a.active{\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tborder-left: 5px solid var(--color-menu-active-text);\r\n\tcolor: var(--color-menu-active-text);\r\n}\r\n\r\n.toggle-menu{\r\n\tcursor: pointer;\r\n    padding: 22px;\r\n    font-size: 24px;\r\n\tcolor: var(--color-primary-green);\r\n\tmargin-left: -15px;\r\n}\r\n.toggle-menu:hover{\r\n\ttext-shadow: 0px 0px 20px var(--color-primary-green);\r\n}\r\n.dropdown-item:focus{\r\n\tbackground-color: inherit;\r\n\tcolor: var(--color-white);\r\n}\r\n\r\n.last-child .mm-collapse{\r\n\tpadding-bottom: 100px;\r\n}\r\n/* --- Sidebar Layer Fix --- */\r\n.sidebar-wrapper,\r\n.sidebar-header {\r\n  position: fixed;\r\n  z-index: 2000 !important;\r\n}\r\n\r\n/* Keep main content below the sidebar */\r\n/* .main,\r\n.content-wrapper,\r\n.ticket-info-card,\r\n.card {\r\n  position: relative;\r\n  z-index: 1;\r\n} */\r\n\r\n/* Optional: ensure mobile sidebar still stays on top */\r\n@media (max-width: 768px) {\r\n  .sidebar-wrapper {\r\n    width: 100%;\r\n    z-index: 3000 !important;\r\n  }\r\n}\r\n.css-26l3qy-menu {\r\n  z-index: 9999 !important;\r\n}\r\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\r\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\r\n\tcolor: var(--color-menu-hover-text);\r\n}\r\n.content-wrapper {\r\n  overflow-y: auto;\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n.content-wrapper::-webkit-scrollbar {\r\n  display: none; /* Chrome/Safari/Edge */\r\n}\r\n.sidebar-wrapper .metismenu .menu-active .parent-icon,\r\n.sidebar-body .metismenu li a.active .parent-icon,\r\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.sidebar-wrapper .metismenu a,\r\n.sidebar-wrapper .metismenu ul a,\r\n.sidebar-wrapper .metismenu ul ul a,\r\n.sidebar-wrapper .metismenu ul ul ul a,\r\n.sidebar-button,\r\n.dropdown-item,\r\n.dropdown-item a,\r\n.menu-title,\r\n.sub-menu-title {\r\n\tfont-size: 0.9rem !important;\r\n\tfont-weight: 600 !important;\r\n}\r\n\r\n.collapsed-menu-parent-icon{\r\n\tcursor: pointer;\r\n\twidth: 100%;\r\n\tcolor: var(--color-icon-slate);\r\n\tpadding: 13px 0;\r\n\tfont-size: 18px;\r\n\tborder-radius: 6px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n.collapsed-menu-parent-icon.hovered{\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tcolor: var(--color-menu-active-text);\r\n\t\r\n}\r\n.collapsed-menu-parent-icon.hovered i{\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.collapsed-menu-parent-icon i{\r\n\tcolor: inherit;\r\n}\r\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered){\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tborder-left: 5px solid var(--color-menu-active-text);\r\n}\r\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i{\r\n\tcolor: var(--color-menu-active-text) !important;\r\n}\r\n\r\n.sidebar-body .metismenu li a.active{\r\n\tbackground-color: var(--color-menu-active-bg);\r\n\tborder-left: 5px solid var(--color-menu-active-text);\r\n\tcolor: var(--color-menu-active-text);\r\n}\r\n\r\n.toggle-menu{\r\n\tcursor: pointer;\r\n    padding: 22px;\r\n    font-size: 24px;\r\n\tcolor: var(--color-primary-green);\r\n}\r\n.toggle-menu:hover{\r\n\ttext-shadow: 0px 0px 20px var(--color-primary-green);\r\n}\r\n.dropdown-item:focus{\r\n\tbackground-color: inherit;\r\n\tcolor: var(--color-white);\r\n}\r\n\r\n.last-child .mm-collapse{\r\n\tpadding-bottom: 100px;\r\n}\r\n/* --- Sidebar Layer Fix --- */\r\n.sidebar-wrapper,\r\n.sidebar-header {\r\n  position: fixed;\r\n  z-index: 2000 !important;\r\n}\r\n\r\n/* Keep main content below the sidebar */\r\n/* .main,\r\n.content-wrapper,\r\n.ticket-info-card,\r\n.card {\r\n  position: relative;\r\n  z-index: 1;\r\n} */\r\n\r\n/* Optional: ensure mobile sidebar still stays on top */\r\n@media (max-width: 768px) {\r\n  .sidebar-wrapper {\r\n    width: 100%;\r\n    z-index: 3000 !important;\r\n  }\r\n}\r\n.css-26l3qy-menu {\r\n  z-index: 9999 !important;\r\n}\r\n.sidebar-wrapper .metismenu li button:hover .parent-icon,\r\n.sidebar-wrapper .metismenu li a:hover .parent-icon{\r\n\tcolor: var(--color-menu-hover-text);\r\n}\r\n.content-wrapper {\r\n  overflow-y: auto;\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n.content-wrapper::-webkit-scrollbar {\r\n  display: none; /* Chrome/Safari/Edge */\r\n}\r\n.sidebar-wrapper .metismenu .menu-active .parent-icon,\r\n.sidebar-body .metismenu li a.active .parent-icon,\r\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) i {\r\n\tcolor: var(--color-primary-green) !important;\r\n}\r\n.sidebar-wrapper .metismenu a,\r\n.sidebar-wrapper .metismenu ul a,\r\n.sidebar-wrapper .metismenu ul ul a,\r\n.sidebar-wrapper .metismenu ul ul ul a,\r\n.sidebar-button,\r\n.dropdown-item,\r\n.dropdown-item a,\r\n.menu-title,\r\n.sub-menu-title {\r\n\tfont-size: 0.9rem !important;\r\n\tfont-weight: 600 !important;\r\n}\r\n/* Active indicator without layout shift */\r\n.collapsed-menu-parent-icon:has(~ .dropdown-menu .active):not(.hovered) {\r\n\tborder-left: none;\r\n\tbox-shadow: inset 5px 0 0 var(--color-menu-active-text);\r\n}\r\n\r\n.sidebar-body .metismenu li a.active {\r\n\tborder-left: 1px solid transparent;\r\n\tbox-shadow: inset 5px 0 0 var(--color-menu-active-text);\r\n}\r\n\r\n.sidebar-wrapper .metismenu .menu-active,\r\n.menu-active:hover {\r\n\tborder-left: 1px solid transparent !important;\r\n\tbox-shadow: inset 3px 0 0 var(--color-menu-active-text);\r\n}\r\n/* Scroll long collapsed-sidebar dropdowns */\r\n.dropdown-menu {\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\tpadding-top: 0;\r\n\tscrollbar-width: thin;\r\n\tscrollbar-color: var(--color-white-a50) transparent;\r\n}\r\n.dropdown-menu::-webkit-scrollbar {\r\n\twidth: 6px;\r\n\tbackground-color: transparent;\r\n}\r\n\r\n/* Keep the menu title visible while scrolling */\r\n.dropdown-item.header {\r\n\tposition: sticky;\r\n\ttop: 0;\r\n\tz-index: 1;\r\n}\r\n.dropdown-item,\r\n.dropdown-item a {\r\n\tline-height: 50px;\r\n}\r\n.dropdown-item a {\r\n\tdisplay: block;\r\n}\r\n.dropdown-menu .dropdown-item.header:not(:only-child) {\r\n\tborder-bottom: 1px solid var(--color-sidebar-border);\r\n\tbox-shadow: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
